"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ReportingEventRequestDetails {
    constructor(userId, sessionId, variableName, variableValue, channel = 'Web', userData, accessKey) {
        this.userId = userId;
        this.sessionId = sessionId;
        this.VariableName = variableName;
        this.VariableValue = variableValue;
        this.channel = channel;
        this.userData = userData;
        this.accessKey = accessKey;
    }
}
exports.default = ReportingEventRequestDetails;
//# sourceMappingURL=ReportingEventRequestDetails.js.map


// WEBPACK FOOTER //
// ../../../Alme/V6/ReportingEventRequestDetails.ts